var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Button, FieldText, Modal, ModalBody, ModalFoot, ModalHead, Tabs, } from '@dixa/lib-shared-habla';
import { boundMethod } from 'autobind-decorator';
import classnames from 'classnames';
import { formatInternational } from 'lib-shared-phone-numbers';
import { PureComponent } from 'react';
import { connect } from 'react-redux';
import { analytics } from 'app/utils/segment';
import { ConfirmModal } from 'components/shared/confirmModal/components/confirmModal';
import { withAvailableCountries, withPhoneNumbers, withPhoneSearch, } from 'hocs';
import { validateName } from 'utils/formValidator';
import CountrySelect from '../countrySelect';
import CustomTab from '../customTab';
import styles from './buyNumber.module.scss';
import '../telephony.less';
const TABS = [
    {
        id: 'local-area-numbers',
        label: 'Local Area Numbers',
    },
    {
        id: 'national-numbers',
        label: 'National Numbers',
    },
];
class BuyNumber extends PureComponent {
    constructor() {
        super(...arguments);
        this.state = {
            showTabs: false,
            name: '',
            isConfirmGroupOpen: false,
            isConfirmNumberOpen: false,
            currentTab: 'local-area-numbers',
            selectedGroup: null,
            selectedNumber: null,
            selectedCountry: null,
        };
    }
    componentDidMount() {
        const { availableCountries: { getItems }, } = this.props;
        getItems().then(({ data: { countries: [firstCountry], }, }) => this.setSelectedCountry(firstCountry));
    }
    onChangePhoneLabel(event) {
        var _a, _b;
        this.setState({ name: (_b = (_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '' });
    }
    setSelectedCountry(selectedCountry) {
        this.setState({ selectedCountry });
    }
    setShowTabs(showTabs) {
        const { numberCountrySelected } = this.props;
        numberCountrySelected();
        this.setState(({ showTabs: stateShowTabs }) => ({
            showTabs: !stateShowTabs && showTabs ? showTabs : stateShowTabs,
        }));
    }
    closeConfirmPurchase(isCancelled = true) {
        const { numberCountrySelected } = this.props;
        if (isCancelled) {
            analytics.phoneFormCancelled();
            // Go back to previous guide step.
            numberCountrySelected();
        }
        this.setState({
            isConfirmGroupOpen: false,
            isConfirmNumberOpen: false,
            selectedGroup: null,
            selectedNumber: null,
        });
    }
    handleConfirmPurchase(query) {
        const { numberSelected } = this.props;
        const { group, number } = query;
        const isConfirmGroupOpen = !!group;
        const isConfirmNumberOpen = !!number;
        numberSelected();
        this.setState({
            isConfirmGroupOpen,
            isConfirmNumberOpen,
            selectedGroup: group !== null && group !== void 0 ? group : null,
            selectedNumber: number !== null && number !== void 0 ? number : null,
        });
    }
    handleTabChange(value) {
        const currentTab = value;
        this.setState({ currentTab });
    }
    handleBuyNumber() {
        const { selectedNumber: number, name } = this.state;
        const { phoneNumbers: { buyNumber }, } = this.props;
        if (!number) {
            return;
        }
        analytics.phoneFormSubmitted();
        buyNumber({ number, name }).then(this.afterPurchase);
    }
    handleBuyGroup() {
        const { selectedGroup: group, name } = this.state;
        const { phoneNumbers: { buyGroup }, } = this.props;
        if (!group) {
            return;
        }
        analytics.phoneFormSubmitted();
        buyGroup({ group, name }).then(this.afterPurchase);
    }
    handleModalClose() {
        const { numberBuyCanceled, hideSearchNumberModal } = this.props;
        numberBuyCanceled();
        hideSearchNumberModal();
    }
    afterPurchase() {
        const { fetchNumbers, numberBuyCanceled, hideSearchNumberModal } = this.props;
        /*
         * In future, we should pass `phoneNumbers`
         * down from phone page, as then we could call `phoneNumbers.getItems` directly.
         * For now, not to break the old phone page we must take `fetchNumbers` and use that.
         */
        fetchNumbers();
        hideSearchNumberModal();
        this.closeConfirmPurchase(false);
        /*
         * Close the guide.
         *
         * Normally we should call `numberPurchased`,
         * however, that part of the guide is outdated and needs reworking.
         */
        numberBuyCanceled();
    }
    renderTabs() {
        const { currentTab } = this.state;
        return (_jsx(Tabs, { tabs: TABS, selectedId: currentTab, onChange: this.handleTabChange, className: "buy-number-modal__tabs" }));
    }
    renderCurrentTab() {
        const { currentTab } = this.state;
        const { phoneSearch } = this.props;
        switch (currentTab) {
            case 'local-area-numbers':
                return (_jsx(CustomTab, { type: "geographic", title: "Local Area Numbers", phoneSearch: phoneSearch, buyNumber: this.handleConfirmPurchase }));
            case 'national-numbers':
                return (_jsx(CustomTab, { type: "national", title: "National Numbers", phoneSearch: phoneSearch, buyNumber: this.handleConfirmPurchase }));
            default:
                return null;
        }
    }
    renderNameField() {
        const { name: value } = this.state;
        return (_jsx(FieldText, { placeholder: "E.g. Support (UK), Support (US), etc.", className: styles.confirmInput, label: "Add a name", meta: {
                error: validateName(value),
            }, input: {
                value,
                onChange: this.onChangePhoneLabel,
                name: 'name',
            } }));
    }
    isNameValid() {
        const { name: nameValue } = this.state;
        return validateName(nameValue) === undefined;
    }
    renderBuyGroupModal() {
        var _a, _b, _c;
        const { currentTab, selectedGroup } = this.state;
        const type = currentTab === 'local-area-numbers' ? 'geographic' : 'national';
        const { phoneNumbers: { purchaseAsyncStatus }, phoneSearch: { items: { [type]: items }, }, } = this.props;
        if (!selectedGroup) {
            return null;
        }
        const { address_requirement } = selectedGroup;
        const isLoading = purchaseAsyncStatus !== 'succeeded';
        const groupCountry = items === null || items === void 0 ? void 0 : items.country;
        const addressRequirement = address_requirement === null || address_requirement === void 0 ? void 0 : address_requirement.requirement_type;
        const isAddressRequired = !!addressRequirement && addressRequirement !== 'worldwide';
        return (_jsx(ConfirmModal, Object.assign({ isShown: true, headline: "Buy a number", confirmText: "Buy number", confirmVariant: "primary", confirmProps: { isLoading, disabled: !this.isNameValid() }, confirm: this.handleBuyGroup, cancelText: "Cancel", cancel: this.closeConfirmPurchase }, { children: _jsxs("div", Object.assign({ className: styles.confirm }, { children: [_jsx("div", Object.assign({ className: styles.confirmText }, { children: "You are about to purchase an area phone number with the following details:" })), _jsxs("dl", Object.assign({ className: classnames('dl-horizontal', styles.confirmRequirements) }, { children: [_jsx("dt", { children: "Country:" }), _jsx("dd", { children: _jsx("span", Object.assign({ className: "text-capitalize" }, { children: ((_a = groupCountry === null || groupCountry === void 0 ? void 0 : groupCountry.country) === null || _a === void 0 ? void 0 : _a.toLowerCase()) || '' })) }), _jsx("dt", { children: "City:" }), _jsx("dd", { children: selectedGroup && (_jsx("span", Object.assign({ className: "text-capitalize" }, { children: ((_b = selectedGroup.city_name) === null || _b === void 0 ? void 0 : _b.toLowerCase()) || '' }))) }), _jsx("dt", { children: "Starting with:" }), _jsx("dd", { children: _jsxs("span", { children: ["(+", groupCountry && groupCountry.country_prefix, ")", ' ', (selectedGroup === null || selectedGroup === void 0 ? void 0 : selectedGroup.area_code) && `${selectedGroup.area_code}...`] }) }), isAddressRequired && (_jsxs(_Fragment, { children: [_jsx("dt", { children: "Address requirements:" }), _jsxs("dd", { children: ["This telephone number requires a ", addressRequirement, " address in", ' ', addressRequirement === 'local' && (_jsxs(_Fragment, { children: [_jsx("span", Object.assign({ className: "text-capitalize" }, { children: selectedGroup.city_name &&
                                                            selectedGroup.city_name.toLowerCase() })), ' ', "(area code ", selectedGroup.area_code, "),", ' '] })), _jsx("span", Object.assign({ className: "text-capitalize" }, { children: (_c = groupCountry === null || groupCountry === void 0 ? void 0 : groupCountry.country) === null || _c === void 0 ? void 0 : _c.toLowerCase() })), ' ', "before the number can be used."] })] }))] })), this.renderNameField()] })) })));
    }
    renderBuyNumberModal() {
        const { selectedNumber } = this.state;
        const { phone_number: { e164_format = '' } = {} } = selectedNumber || {};
        const { phoneNumbers: { purchaseAsyncStatus }, } = this.props;
        const isLoading = purchaseAsyncStatus !== 'succeeded';
        const prettyNumber = formatInternational(e164_format) || e164_format;
        return (_jsx(ConfirmModal, Object.assign({ isShown: true, headline: `You're about to buy ${prettyNumber}`, confirmText: "Buy", confirmVariant: "primary", confirmProps: { isLoading, disabled: !this.isNameValid() }, confirm: this.handleBuyNumber, cancel: this.closeConfirmPurchase }, { children: _jsxs("div", Object.assign({ className: styles.confirm }, { children: [_jsx("div", Object.assign({ className: styles.confirmText }, { children: "Give this number a name so everyone on your team knows what kind of support this phone number will be used for." })), this.renderNameField()] })) })));
    }
    render() {
        const { isOpen, phoneSearch, availableCountries: { items: countries }, } = this.props;
        const { isConfirmNumberOpen, isConfirmGroupOpen, showTabs, selectedCountry, } = this.state;
        const isSubdialogOpen = isConfirmNumberOpen || isConfirmGroupOpen;
        return (_jsxs("div", { children: [_jsx(Modal, Object.assign({ isOpen: isOpen && !isSubdialogOpen, onClose: this.handleModalClose }, { children: _jsxs(Box, Object.assign({ id: "buy-number-modal" }, { children: [_jsx(ModalHead, { title: "Buy a number", onClose: this.handleModalClose }), _jsx(ModalBody, { children: _jsxs("div", Object.assign({ className: styles.modalBody }, { children: [_jsx(CountrySelect, { setShowTabs: this.setShowTabs, phoneSearch: phoneSearch, onSelect: this.setSelectedCountry, countries: countries, selectedCountry: selectedCountry }), showTabs && this.renderTabs(), showTabs && this.renderCurrentTab()] })) }), _jsx(ModalFoot, { children: _jsx("div", Object.assign({ className: "buttons" }, { children: _jsx(Button, Object.assign({ type: "button", variant: "tertiary", className: "pull-left", disabled: status === 'loading', onClick: this.handleModalClose }, { children: "Cancel" })) })) })] })) })), isConfirmGroupOpen && this.renderBuyGroupModal(), isConfirmNumberOpen && this.renderBuyNumberModal()] }));
    }
}
__decorate([
    boundMethod
], BuyNumber.prototype, "onChangePhoneLabel", null);
__decorate([
    boundMethod
], BuyNumber.prototype, "setSelectedCountry", null);
__decorate([
    boundMethod
], BuyNumber.prototype, "setShowTabs", null);
__decorate([
    boundMethod
], BuyNumber.prototype, "closeConfirmPurchase", null);
__decorate([
    boundMethod
], BuyNumber.prototype, "handleConfirmPurchase", null);
__decorate([
    boundMethod
], BuyNumber.prototype, "handleTabChange", null);
__decorate([
    boundMethod
], BuyNumber.prototype, "handleBuyNumber", null);
__decorate([
    boundMethod
], BuyNumber.prototype, "handleBuyGroup", null);
__decorate([
    boundMethod
], BuyNumber.prototype, "handleModalClose", null);
__decorate([
    boundMethod
], BuyNumber.prototype, "afterPurchase", null);
__decorate([
    boundMethod
], BuyNumber.prototype, "renderTabs", null);
const mapDispatchToProps = (dispatch) => ({
    numberBuyCanceled: () => dispatch({ type: 'TELEPHONY_HIDE_SEARCH_NUMBER_MODAL' }),
    numberCountrySelected: () => dispatch({ type: 'TELEPHONY_BUY_NUMBER_COUNTRY_SELECTED' }),
    numberSelected: () => dispatch({ type: 'TELEPHONY_BUY_NUMBER_OPTION_SELECTED' }),
    numberPurchased: () => dispatch({ type: 'TELEPHONY_BUY_NUMBER_PURCHASED' }),
});
export default connect(null, mapDispatchToProps)(withPhoneNumbers(withPhoneSearch(withAvailableCountries(BuyNumber))));
